import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArtworkCard } from "@/features/artwork/components/artwork-card";
import { createFileRoute } from "@tanstack/react-router";
import { useUpdateEffect } from "ahooks";
import { BookDashedIcon, LockIcon } from "lucide-react";
import { motion } from "motion/react";
import { shuffle } from "radashi";
import { useState } from "react";

export const Route = createFileRoute("/user/$username/gallery")({
  component: RouteComponent,
});

const __mock__artworks = [...Array(32)].map((_, i) => ({
  imageUrl: `https://picsum.photos/seed/artwork-${i + 31}/512.webp`,
  authorAvatarUrl: "",
  authorName: "SX",
  title: `Title ${i + 1}`,
  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  href: "/",
}));

const AnimatedArtworkCard = motion.create(ArtworkCard);

function RouteComponent() {
  const [selectedTab, setSelectedTab] = useState("latest");
  const [sortedArtworks, setSortedArtworks] = useState(__mock__artworks);

  useUpdateEffect(() => {
    setSortedArtworks(shuffle(sortedArtworks));
  }, [selectedTab]);

  return (
    <div>
      <Tabs
        className="my-4"
        defaultValue={selectedTab}
        onValueChange={setSelectedTab}
        flavor="graya"
      >
        <TabsList className="text-sm">
          <TabsTrigger value="latest">最新发布</TabsTrigger>
          <TabsTrigger value="most-liked">最多点赞</TabsTrigger>
          <TabsTrigger value="private">
            <LockIcon />
            私密
          </TabsTrigger>
          <TabsTrigger value="drafts">
            <BookDashedIcon />
            草稿
          </TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
        {sortedArtworks.map((artwork, _i) => (
          <AnimatedArtworkCard
            key={artwork.imageUrl}
            imageUrl={artwork.imageUrl}
            authorAvatarUrl={artwork.authorAvatarUrl}
            authorName={artwork.authorName}
            title={artwork.title}
            description={artwork.description}
            link={{
              to: "/artwork/$artworkId/modal",
              params: { artworkId: _i.toString() },
            }}
            layout
            transition={{
              type: "spring",
              damping: 25,
              stiffness: 120,
            }}
          />
        ))}
      </div>
    </div>
  );
}
